import { render, staticRenderFns } from "./CopyCriteriaButton.vue?vue&type=template&id=4e481b85&scoped=true"
import script from "./CopyCriteriaButton.vue?vue&type=script&lang=js"
export * from "./CopyCriteriaButton.vue?vue&type=script&lang=js"
import style0 from "./CopyCriteriaButton.vue?vue&type=style&index=0&id=4e481b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e481b85",
  null
  
)

export default component.exports